import type { FC } from "react";
import React from "react";

import cn from "classnames";

import { createDisplayNameForAvaPictureElement } from "../../utils/getDisplayName";
import { createTestIdForAvaPictureElement } from "../../utils/getTestId";

import type { PropsWithCustomVarsStyles } from "../../../../types/react";
import type { AvaPictureShapes, AvaPictureSizes } from "../../types";

import classes from "./AvaPictureInitials.styl";

type AvaPictureInitialsPrivateProps = PropsWithCustomVarsStyles<{
    /** Отвечает за текст компонента (макс. 2 символа) */
    initialsValue: string;
    size: AvaPictureSizes;
    shape: AvaPictureShapes;
}>;

export type AvaPictureInitialsProps = Omit<
    AvaPictureInitialsPrivateProps,
    "size" | "shape"
>;

export const AVA_PICTURE_INITIALS_TEST_ID =
    createTestIdForAvaPictureElement("initials");

const INITIALS_MAX_LENGTH = 2;

export const AvaPictureInitials: FC<AvaPictureInitialsProps> = (props) => {
    const { initialsValue, size, shape, customVarsStyles } =
        props as AvaPictureInitialsPrivateProps;

    const classNames = cn(
        classes["initials"],
        classes[`__size-${size}`],
        classes[`__shape-${shape}`],
        customVarsStyles,
    );

    return (
        <div data-tsid={AVA_PICTURE_INITIALS_TEST_ID} className={classNames}>
            {initialsValue!.length > INITIALS_MAX_LENGTH
                ? initialsValue!.substring(0, INITIALS_MAX_LENGTH)
                : initialsValue}
        </div>
    );
};

AvaPictureInitials.displayName =
    createDisplayNameForAvaPictureElement("Initials");

export default AvaPictureInitials;
